import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
import { Container } from '@mantine/core'

export const StyledContainer = styled(Container)`
  position: sticky;
  z-index: 10;
  padding: 16px;
  background: white;
  border-bottom: 1px solid ${theme?.colors.neutral100};

  ${MediaQueries.mbDown} {
    padding-block: 8px;
  }
  &[data-is-sponsored='false'] {
    ${MediaQueries.mbUp} {
      top: 69px;
    }
  }

  &[data-is-sponsored='true'] {
    ${MediaQueries.mbUp} {
      top: 100px;
    }
  }
`
